import VerifyOutItemTransfer from "../../../../components/@documents/item_transfers/VerifyOutItemTransfer";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemTransferVerifyOutPage() {

    return (
        <VerifyOutItemTransfer
            routeType={routeTypes.retail}
        />
    )
}